<template>
  <span></span>
</template>

<script>
import { mdiImageOutline } from '@mdi/js'

export default {
  title: 'diaryImage',
  description: 'Insert Image',
  icon: `<svg viewBox="0 0 24 24"><path d="${mdiImageOutline}" /></svg>`,
  props: {
    options: { type: Object, required: true },
  },
  watch: {
    '$parent.showDashboard'(open) {
      if (open) this.openUpload()
    },
  },
  methods: {
    openUpload() {
      this.$parent.closeDashboard()
      this.options.onOpenUpload()
    },
  },
}
</script>
